(() => {
  'use strict';
  const state = window.WANDRY_AB_STATE;
  if (!state || state.redirecting) return;
  const record = state.record;
  const attrs = {'__ec_ab_exp':record.e, '__ec_ab_variant':record.v, '__ec_ab_vid':record.id, '__ec_ab_assigned_at':new Date(record.t).toISOString()};
  let pending = null, cartReady = false, tagsSent = false, viewSent = false, backgroundStarted = false;
  const allowed = () => {
    try { return !state.qa && window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true; }
    catch (_) { return false; }
  };
  const ensureCart = () => {
    if (!allowed()) return Promise.resolve(false);
    if (cartReady) return Promise.resolve(true);
    if (pending) return pending;
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 1800);
    pending = fetch((window.Shopify?.routes?.root || '/') + 'cart/update.js', {
      method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({attributes:attrs}), signal:controller.signal
    }).then(async response => {
      if (!response.ok) return false;
      const cart = await response.json();
      // Private attributes are intentionally omitted from cart reads.
      // This confirms acceptance; order inheritance is checked separately.
      cartReady = typeof cart.item_count === 'number' && Array.isArray(cart.items);
      return cartReady;
    }).catch(() => false).finally(() => {clearTimeout(timer);pending=null;});
    return pending;
  };
  const event = name => {
    if (!allowed() || typeof window.clarity !== 'function') return false;
    if (!tagsSent) {
      window.clarity('set','ab_experiment',record.e);
      window.clarity('set','ab_variant',record.v);
      window.clarity('set','ab_entry','advertorial-01-paid');
      tagsSent = true;
    }
    if (name) window.clarity('event',name);
    return true;
  };
  const sync = () => {
    if (!allowed()) return;
    const article = location.pathname.replace(/\/$/,'') === '/pages/advertorial-' + record.v;
    if (article && !viewSent) viewSent = event('ec_ab_article_' + record.v + '_viewed');
    else event(null);
    if(!backgroundStarted){backgroundStarted=true;void ensureCart();}
  };
  window.WANDRY_AB = Object.freeze({ensureCart, diagnostics:() => ({experiment:record.e,variant:record.v,qa:state.qa,cartReady,tagsSent,viewSent,analyticsAllowed:allowed()})});
  document.addEventListener('visitorConsentCollected',sync);
  // Normal Shopify checkout submits these attributes with the same cart request.
  // It never waits on an analytics request or prevents a purchase.
  document.addEventListener('submit',e => {
    const form=e.target, submitter=e.submitter;
    if (!allowed() || !(form instanceof HTMLFormElement) || submitter?.name !== 'checkout') return;
    let target;try{target=new URL(form.action,location.href);}catch(_){return;}
    if(target.origin!==location.origin || !/^\/(?:[a-z]{2}(?:-[A-Z]{2})?\/)?cart\/?$/.test(target.pathname))return;
    for(const [key,value] of Object.entries(attrs)) {
      const name='attributes['+key+']';
      let input=Array.from(form.elements).find(el=>el.name===name);
      if(!input){input=document.createElement('input');input.type='hidden';input.name=name;form.appendChild(input);}
      input.value=value;
    }
    event('ec_ab_checkout_' + record.v);
  },true);
  const ready = () => {
    if(state.qa){
      // Preview parameters follow the CTA, but are never enrolled or sent to analytics.
      document.querySelectorAll('a[href]').forEach(a=>{const u=new URL(a.href,location.href);if(u.origin===location.origin&&u.pathname.startsWith('/products/')){u.searchParams.set('ec_qa','1');u.searchParams.set('ab_preview',record.v);a.href=u.href;}});
      return;
    }
    document.addEventListener('click',e=>{const a=e.target.closest?.('a[href]');if(a&&new URL(a.href,location.href).pathname.startsWith('/products/'))event('ec_ab_product_click_'+record.v);},{passive:true});
    sync();
    if(window.Shopify?.loadFeatures && !window.Shopify.customerPrivacy){
      window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],error=>{if(!error)sync();});
    }
    // Existing Shopify/Clarity loaders can arrive after DOMContentLoaded.
    let attempts=0;
    const timer=setInterval(()=>{sync();if(++attempts>=20||(tagsSent&&cartReady))clearInterval(timer);},500);
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',ready,{once:true});else ready();
})();
